import { render, staticRenderFns } from "./CategoriesOptions.vue?vue&type=template&id=f863f79c"
import script from "./CategoriesOptions.vue?vue&type=script&lang=js"
export * from "./CategoriesOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports